// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__NCd5V","Loading__spinner":"Loading_Loading__spinner__ddEaH","spin":"Loading_spin__lR5EZ"};